(function () {
  function initCarbonCnaughtSection(section) {
    if (!section || section.dataset.carbonCnaughtInitialised === 'true') return;

    section.dataset.carbonCnaughtInitialised = 'true';

    var API_TOKEN = section.dataset.apiToken || '';
    var IMPACT_API_URL = section.dataset.impactApiUrl || 'https://api.cnaught.com/v1/impact/data';

    var totalNumberEl = section.querySelector('[data-carbon-total-number]');
    var totalStateEl = section.querySelector('[data-carbon-total-state]');

    var cards = section.querySelectorAll('.carbon-cnaught__card');
    var apiState = section.querySelector('[data-api-state]');

    var modal = section.querySelector('.carbon-cnaught-modal');
    var closeButtons = section.querySelectorAll('[data-close-modal]');

    var modalImage = section.querySelector('.carbon-cnaught-modal__image');
    var modalTitle = section.querySelector('.carbon-cnaught-modal__title');
    var modalSummary = section.querySelector('.carbon-cnaught-modal__summary');
    var metaWrap = section.querySelector('.carbon-cnaught-modal__meta');
    var impactWrap = section.querySelector('.carbon-cnaught-modal__impact');
    var beyondWrap = section.querySelector('.carbon-cnaught-modal__beyond');
    var dueWrap = section.querySelector('.carbon-cnaught-modal__due');
    var riskWrap = section.querySelector('.carbon-cnaught-modal__risk');
    var labelsWrap = section.querySelector('.carbon-cnaught-modal__labels');
    var sdgsWrap = section.querySelector('.carbon-cnaught-modal__sdgs');
    var issuancesWrap = section.querySelector('.carbon-cnaught-modal__issuances');

    var sectionImpact = section.querySelector('.carbon-cnaught-modal__section--impact');
    var sectionBeyond = section.querySelector('.carbon-cnaught-modal__section--beyond');
    var sectionDue = section.querySelector('.carbon-cnaught-modal__section--due');
    var sectionRisk = section.querySelector('.carbon-cnaught-modal__section--risk');
    var sectionLabels = section.querySelector('.carbon-cnaught-modal__section--labels');
    var sectionSdgs = section.querySelector('.carbon-cnaught-modal__section--sdgs');
    var sectionIssuances = section.querySelector('.carbon-cnaught-modal__section--issuances');

    var loadingState = section.querySelector('.carbon-cnaught-modal__state--loading');
    var errorState = section.querySelector('.carbon-cnaught-modal__state--error');

    var projectCache = {};

    function setTotalState(message) {
      if (!totalStateEl) return;

      totalStateEl.textContent = message || '';
      totalStateEl.hidden = !message;
    }

    function setApiState(message) {
      if (!apiState) return;

      apiState.textContent = message || '';
      apiState.hidden = !message;
    }

    function formatTonnes(value) {
      var number = Number(value || 0);
      var decimals = Number.isInteger(number) ? 0 : 2;

      return number.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimals
      });
    }

    function setTotalTonnes(value) {
      if (!totalNumberEl) return;

      totalNumberEl.classList.remove('is-loading');
      totalNumberEl.textContent = formatTonnes(value);
      setTotalState('');
    }

    function findNumberByKeys(source, keys, maxDepth) {
      if (!source || typeof source !== 'object' || maxDepth < 0) return 0;

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];

        if (Object.prototype.hasOwnProperty.call(source, key)) {
          var value = Number(source[key]);

          if (!Number.isNaN(value) && value > 0) {
            return value;
          }
        }
      }

      var objectKeys = Object.keys(source);

      for (var j = 0; j < objectKeys.length; j++) {
        var child = source[objectKeys[j]];

        if (child && typeof child === 'object') {
          var found = findNumberByKeys(child, keys, maxDepth - 1);

          if (found > 0) {
            return found;
          }
        }
      }

      return 0;
    }

    function getTotalTonnesFromApi(data) {
      var kgKeys = [
        'total_offset_kgs',
        'totalOffsetKgs',
        'total_offset_kg',
        'totalOffsetKg',
        'total_carbon_credited_kgs',
        'totalCarbonCreditedKgs',
        'carbon_credits_applied_kgs',
        'carbonCreditsAppliedKgs'
      ];

      var tonneKeys = [
        'total_offset_tonnes',
        'totalOffsetTonnes',
        'total_tonnes',
        'totalTonnes',
        'tonnes',
        'total_carbon_credited',
        'totalCarbonCredited',
        'cumulative_carbon_credited',
        'cumulativeCarbonCredited',
        'carbon_credits_applied',
        'carbonCreditsApplied'
      ];

      var kgValue = findNumberByKeys(data, kgKeys, 4);

      if (kgValue > 0) {
        return kgValue / 1000;
      }

      return findNumberByKeys(data, tonneKeys, 4);
    }

    function fetchImpactTotal() {
      if (!API_TOKEN) {
        if (totalNumberEl) {
          totalNumberEl.classList.remove('is-loading');
          totalNumberEl.textContent = '—';
        }

        setTotalState('Add the CNaught API token to load the live total.');
        return;
      }

      fetch(IMPACT_API_URL, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + API_TOKEN,
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          return response.text().then(function (text) {
            if (!response.ok) {
              throw new Error('CNaught impact API error ' + response.status + ': ' + text);
            }

            try {
              return JSON.parse(text);
            } catch (error) {
              throw new Error('Invalid CNaught JSON response: ' + text);
            }
          });
        })
        .then(function (data) {
          var totalTonnes = getTotalTonnesFromApi(data);

          if (!totalTonnes || totalTonnes <= 0) {
            throw new Error('Total tonnes field not found in CNaught response.');
          }

          setTotalTonnes(totalTonnes);
        })
        .catch(function (error) {
          console.error(error);

          if (totalNumberEl) {
            totalNumberEl.classList.remove('is-loading');
            totalNumberEl.textContent = '—';
          }

          setTotalState('Unable to load live CNaught total right now.');
        });
    }

    function fetchProject(projectId) {
      if (!projectId || !API_TOKEN) {
        return Promise.reject(new Error('Missing project ID or CNaught API token'));
      }

      return fetch('https://api.cnaught.com/v1/projects/' + encodeURIComponent(projectId), {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + API_TOKEN
        }
      }).then(function (res) {
        if (!res.ok) throw new Error('CNaught project API request failed');
        return res.json();
      });
    }

    function getFallback(card) {
      return {
        title: card.getAttribute('data-title') || '',
        summary: card.getAttribute('data-summary') || '',
        image: card.getAttribute('data-image') || '',
        imageAlt: card.getAttribute('data-image-alt') || card.getAttribute('data-title') || ''
      };
    }

    function getProjectTitle(data, fallback) {
      return data.name || data.title || fallback.title || '';
    }

    function getProjectSummary(data, fallback) {
      return data.description || data.summary || data.short_description || fallback.summary || '';
    }

    function getProjectImage(data, fallback) {
      return data.primary_image_url || data.image_url || fallback.image || '';
    }

    function updateCard(card, data) {
      var fallback = getFallback(card);
      var title = getProjectTitle(data, fallback);
      var summary = getProjectSummary(data, fallback);
      var image = getProjectImage(data, fallback);

      var titleEl = card.querySelector('[data-card-title]');
      var summaryEl = card.querySelector('[data-card-summary]');
      var imageEl = card.querySelector('.carbon-cnaught__image img');

      if (titleEl && title) titleEl.textContent = title;
      if (summaryEl && summary) summaryEl.textContent = summary;

      if (imageEl && image) {
        imageEl.src = image;
        imageEl.alt = title || fallback.imageAlt || '';
      }
    }

    function prefetchProjects() {
      if (!API_TOKEN || !cards.length) {
        setApiState('Add the CNaught API token to load live project details.');
        return;
      }

      setApiState('Loading live CNaught project details...');

      var requests = Array.prototype.map.call(cards, function (card) {
        var projectId = card.getAttribute('data-project-id');

        if (!projectId) return Promise.resolve();

        return fetchProject(projectId)
          .then(function (data) {
            projectCache[projectId] = data;
            updateCard(card, data);
          })
          .catch(function (err) {
            console.error(err);
          });
      });

      Promise.all(requests).then(function () {
        setApiState('');
      });
    }

    function openModal() {
      if (!modal) return;

      modal.hidden = false;
      document.body.classList.add('carbon-cnaught-modal-open');
    }

    function closeModal() {
      if (!modal) return;

      modal.hidden = true;
      document.body.classList.remove('carbon-cnaught-modal-open');
    }

    function resetModal() {
      metaWrap.innerHTML = '';
      impactWrap.innerHTML = '';
      beyondWrap.innerHTML = '';
      dueWrap.innerHTML = '';
      riskWrap.innerHTML = '';
      labelsWrap.innerHTML = '';
      sdgsWrap.innerHTML = '';
      issuancesWrap.innerHTML = '';

      sectionImpact.hidden = true;
      sectionBeyond.hidden = true;
      sectionDue.hidden = true;
      sectionRisk.hidden = true;
      sectionLabels.hidden = true;
      sectionSdgs.hidden = true;
      sectionIssuances.hidden = true;

      errorState.hidden = true;
      loadingState.hidden = true;
    }

    function setImage(src, alt) {
      if (src) {
        modalImage.src = src;
        modalImage.alt = alt || '';
        modalImage.hidden = false;
      } else {
        modalImage.src = '';
        modalImage.alt = '';
        modalImage.hidden = true;
      }
    }

    function addMetaItem(label, value) {
      if (!value) return;

      var item = document.createElement('div');
      var strong = document.createElement('strong');
      var span = document.createElement('span');

      item.className = 'carbon-cnaught-modal__meta-item';
      strong.textContent = label;
      span.textContent = value;

      item.appendChild(strong);
      item.appendChild(span);
      metaWrap.appendChild(item);
    }

    function renderTags(container, items, prefix) {
      if (!Array.isArray(items) || !items.length) return false;

      items.forEach(function (item) {
        var tag = document.createElement('span');

        tag.className = 'carbon-cnaught-modal__tag';
        tag.textContent = prefix ? prefix + item : item;
        container.appendChild(tag);
      });

      return true;
    }

    function renderIssuances(items) {
      if (!Array.isArray(items) || !items.length) return false;

      items.forEach(function (item) {
        var row = document.createElement('div');
        var yearSpan = document.createElement('span');
        var amountSpan = document.createElement('span');

        var year = item && item.vintage_year ? item.vintage_year : 'N/A';
        var amount = item && typeof item.total_amount !== 'undefined'
          ? Number(item.total_amount).toLocaleString()
          : 'N/A';

        row.className = 'carbon-cnaught-modal__issuance';
        yearSpan.textContent = 'Vintage year: ' + year;
        amountSpan.textContent = 'Total amount: ' + amount;

        row.appendChild(yearSpan);
        row.appendChild(amountSpan);
        issuancesWrap.appendChild(row);
      });

      return true;
    }

    function formatLifetime(lifetime) {
      if (!lifetime) return '';

      if (typeof lifetime === 'string') return lifetime;

      if (typeof lifetime === 'object') {
        var parts = [];

        if (lifetime.start_year) parts.push('Start: ' + lifetime.start_year);
        if (lifetime.end_year) parts.push('End: ' + lifetime.end_year);
        if (lifetime.years) parts.push('Years: ' + lifetime.years);
        if (lifetime.description) parts.push(lifetime.description);

        return parts.join(' | ');
      }

      return '';
    }

    function renderProjectData(data, fallback) {
      var title = getProjectTitle(data, fallback);
      var summary = getProjectSummary(data, fallback);

      modalTitle.textContent = title;
      modalSummary.textContent = summary;
      setImage(getProjectImage(data, fallback), title || fallback.imageAlt);

      addMetaItem('Impact type', data.impact_type);
      addMetaItem('Methodology', data.methodology);
      addMetaItem('Verifier', data.verifier);
      addMetaItem('Permanence', data.permanence);
      addMetaItem('Lifetime', formatLifetime(data.lifetime));
      addMetaItem('Longitude', data.location_longitude);

      if (data.impact_type || data.methodology || data.verifier || data.permanence || data.lifetime || data.location_longitude) {
        sectionImpact.hidden = false;
        impactWrap.textContent = 'This project contributes through ' + (data.impact_type || 'verified climate action') + '.';
      }

      if (data.beyond_carbon) {
        beyondWrap.textContent = data.beyond_carbon;
        sectionBeyond.hidden = false;
      }

      if (data.due_diligence) {
        dueWrap.textContent = data.due_diligence;
        sectionDue.hidden = false;
      }

      if (data.risk_of_reversal) {
        riskWrap.textContent = data.risk_of_reversal;
        sectionRisk.hidden = false;
      }

      if (renderTags(labelsWrap, data.third_party_labels || [])) {
        sectionLabels.hidden = false;
      }

      if (renderTags(sdgsWrap, data.un_sdg_goals || [], 'Goal ')) {
        sectionSdgs.hidden = false;
      }

      if (renderIssuances(data.credit_issuances || [])) {
        sectionIssuances.hidden = false;
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        resetModal();
        openModal();

        var fallback = getFallback(card);
        var projectId = card.getAttribute('data-project-id');

        modalTitle.textContent = fallback.title;
        modalSummary.textContent = fallback.summary;
        setImage(fallback.image, fallback.imageAlt || fallback.title);

        if (projectCache[projectId]) {
          renderProjectData(projectCache[projectId], fallback);
          return;
        }

        if (!projectId || !API_TOKEN) {
          errorState.hidden = false;
          return;
        }

        loadingState.hidden = false;

        fetchProject(projectId)
          .then(function (data) {
            projectCache[projectId] = data;
            loadingState.hidden = true;
            renderProjectData(data, fallback);
            updateCard(card, data);
          })
          .catch(function (err) {
            console.error(err);
            loadingState.hidden = true;
            errorState.hidden = false;
          });
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });

    fetchImpactTotal();
    prefetchProjects();
  }

  function initAllCarbonCnaughtSections(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-carbon-cnaught-section]').forEach(function (section) {
      initCarbonCnaughtSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllCarbonCnaughtSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllCarbonCnaughtSections(event.target);
  });
})();